import type { RequireExactlyOne } from 'type-fest'
import { z } from 'zod'

import { nonEmptyArraySchema } from '@mntn-dev/utilities'
import type { NonEmptyArray } from '@mntn-dev/utility-types'

/**
 *
 * @param schema the schema of the model field to be filtered (must be string or number)
 * @returns A schema that accepts a single value or a non-empty array of values
 */
export const ModelFilterSchema = <
  FieldSchema extends z.ZodType<string | number | boolean>,
>(
  schema: FieldSchema
) => z.union([schema, nonEmptyArraySchema(schema)])

export type ModelFilter<Field extends string | number | boolean> =
  | Field
  | NonEmptyArray<Field>

/**
 *
 * @param schema the schema of the model field to be filtered (must be string or number)
 * @returns A schema containing the range filter fields
 */
export const ModelRangeSchema = <
  FieldSchema extends z.ZodType<string | number>,
>(
  schema: FieldSchema
) =>
  z.union([
    z.object({ lt: schema }).strict(),
    z.object({ lte: schema }).strict(),
    z.object({ gte: schema }).strict(),
    z.object({ gt: schema }).strict(),
  ])

export type ModelRange<Field extends string | number> = RequireExactlyOne<{
  lt: Field
  lte: Field
  gte: Field
  gt: Field
}>
